import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left"
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "maintitle s60" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = {
  id: "Main",
  class: "right"
}
const _hoisted_9 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = { class: "intro" }
const _hoisted_13 = { class: "maintitle s36" }
const _hoisted_14 = {
  ref: "form",
  class: "form"
}
const _hoisted_15 = {
  class: "item",
  "data-type": "list"
}
const _hoisted_16 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_19 = {
  class: "group",
  "data-type": "buttons"
}
const _hoisted_20 = { class: "cta" }
const _hoisted_21 = {
  key: 0,
  class: "cta secondary"
}

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountProfileSegmentEdit',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const profileSegments = ref<any[]>([]);
const editData = ref<any>(null);
const formData = ref<any>({ profileSegment: null });
const validationErrors = ref<any[]>([]);

onBeforeMount(() => {
    getData();
});

async function getData() {
    editData.value = (await Axios.post(routes.Account_Profile_GetEditSegmentData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    formData.value.profileSegment = editData.value.profileSegment;
    profileSegments.value = editData.value.profileSegments;
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;
    try {
        let result = (await Axios.post(routes.Account_Profile_EditSegment, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;
        window.location.href = result.redirectUrl ? result.redirectUrl : (props.returnUrl ? props.returnUrl : "/");
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
    isLoading.value = false;
}

function notNow() {
    window.location.href = props.returnUrl ? props.returnUrl : "/";
}

function goBack() {
    this.returnUrl ? window.location.href = this.returnUrl : history.back();
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.User.Experience_Title")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.User.Experience_Description")), 1)
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_11)
        ], 8, _hoisted_10)
      ]),
      (editData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
            class: "content"
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(localizer).get("App.Common.AddFunctionalities")), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileSegments.value, (profileSegment, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "radio"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "profileSegments",
                        id: profileSegment.value,
                        value: profileSegment.value,
                        "onUpdate:modelValue": ($event: any) => ((formData.value.profileSegment) = $event)
                      }, null, 8, _hoisted_16), [
                        [_vModelRadio, formData.value.profileSegment]
                      ]),
                      _createElementVNode("label", {
                        for: profileSegment.value
                      }, _toDisplayString(profileSegment.title), 9, _hoisted_17)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("fieldset", null, [
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'loading': isSuccess.value }, 'button']),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm()))
                    }, [
                      (!isSuccess.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  (!isSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("button", {
                          class: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (notNow()))
                        }, _toDisplayString(_unref(localizer).get("Account.Common.NotNow")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 512)
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})